import React from 'react'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Helmet } from 'react-helmet'

// Import images
import BannerImg from '../assets/images/banners/Banner1.webp'
import TeamMember from '../components/team/TeamMember'
import AanilImg from '../assets/images/Aanil.webp'
// import PriyankaImg from '../assets/images/Priyenka.png'
import FaraazImg from '../assets/images/Faraz.webp'
// import RidhiImg from '../assets/images/Ridhi.webp'
// import KhushiImg from '../assets/images/Khushi.webp'
// import RiyaImg from '../assets/images/Riya.jpg'
import BhwnaImg from '../assets/images/BhwnaManvani.jpg'
// import ArsalanImg from '../assets/images/Arsalan.webp'
import AjmalImg from '../assets/images/Ajmal.png'
import AnumImg from '../assets/images/Anum.png'
import UdayImg from '../assets/images/Uday.png'
import YashImg from '../assets/images/Yash.png'
import AnamImg from '../assets/images/Anam.png'
// import AmalImg from '../assets/images/Amal.png'
// import ManalImg from '../assets/images/Manal.png'
import FrancisImg from '../assets/images/Francis.png'
import RiyaImg from '../assets/images/Riya.jpg'
import ProfileImg from '../assets/images/Profile.png'
import LakshayImg from '../assets/images/Lakshay.png'

const TeamPage = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Our Team | 800 Homes</title>
                <meta
                    name="description"
                    content="Our team of experts at 800 Homes is dedicated to helping you find your dream home in Dubai. Our team is made up of experienced professionals who are passionate about real estate and committed to providing exceptional service to our clients."
                />

                <meta property="og:type" content="website" />
                <meta property="og:title" content="Our Team | 800 Homes" />
                <meta
                    property="og:description"
                    content="Our team of experts at 800 Homes is dedicated to helping you find your dream home in Dubai. Our team is made up of experienced professionals who are passionate about real estate and committed to providing exceptional service to our clients."
                />
                <meta property="og:url" content="https://800homes.ae/" />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content="https://800homes.ae/og.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content="https://800homes.ae/og.webp" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:description"
                    content="Our team of experts at 800 Homes is dedicated to helping you find your dream home in Dubai. Our team is made up of experienced professionals who are passionate about real estate and committed to providing exceptional service to our clients."
                />
                <meta name="twitter:title" content="Our Team | 800 Homes" />
                <meta name="twitter:image" content="https://800homes.ae/og.webp" />
                <link rel="canonical" href="https://800homes.ae/our-team/" />
            </Helmet>
            <Header />

            {/* Banner Section */}
            <section
                id="website-responsive"
                className="container-fluid common-banner shadow-800homes"
                style={{ backgroundImage: `url(${BannerImg})` }}
            >
                <div className="row justify-content-center align-items-center">
                    <div className="col-11 col-lg-10">
                        <h1 className="lh-sm fw-600 banner-title text-uppercase text-white text-center">Our Team</h1>
                        <div></div>
                    </div>
                </div>
            </section>

            <section className="pt-5 mt-md-5" />

            <div className="container-fluid">
                <div className="row justify-content-center gy-5">
                    <TeamMember
                        ProfileImg={FaraazImg}
                        Title1="Faraaz Siddiqui"
                        Title2="General Manager"
                        Link="/faraaz-siddiqui"
                    />

                    {/* <TeamMember
                        ProfileImg={PriyankaImg}
                        Title1="Priyanka Dev"
                        Title2="Sales Director"
                        Link="/priyanka-dev"
                    /> */}

                    <TeamMember
                        ProfileImg={BhwnaImg}
                        Title1="Bhwna Manvani"
                        Title2="Sales Director"
                        Link="/bhwna-manvani"
                    />

                    <TeamMember
                        ProfileImg={AanilImg}
                        Title1="Aanil Mannwani"
                        Title2="Sales Director"
                        Link="/aanil-mannwani"
                    />

                    {/* <TeamMember
                        ProfileImg={RidhiImg}
                        Title1="Riddhi Bhagchandani"
                        Title2="Property Consultant"
                        Link="/riddhi-bhagchandani"
                    /> */}

                    {/* <TeamMember
                        ProfileImg={ArsalanImg}
                        Title1="Arsalan Nadkar"
                        Title2="VP Sales"
                        Link="/arsalan-nadkar"
                    /> */}

                    {/* <TeamMember
                        ProfileImg={ArsalanImg}
                        Title1="Mohamed Elnagr"
                        Title2="Sales Director"
                        Link="/mohamed-elnagr"
                    /> */}

                    {/* <TeamMember
                        ProfileImg={AmalImg}
                        Title1="Amal Ben Youssef"
                        Title2="Property Consultant"
                        Link="/amal-ben-youssef"
                    /> */}

                    {/* <TeamMember
                        ProfileImg={ManalImg}
                        Title1="Manal Mahri"
                        Title2="Property Consultant"
                        Link="/manal-mahri"
                    /> */}

                    <TeamMember
                        ProfileImg={ProfileImg}
                        Title1="Zunaira Hussain"
                        Title2="Lead Generation Executive"
                        Link="/zunaira-hussain"
                    />

                    <TeamMember ProfileImg={UdayImg} Title1="Uday" Title2="Property Consultant" Link="/uday" />

                    <TeamMember ProfileImg={YashImg} Title1="Yash" Title2="Property Consultant" Link="/yash" />

                    <TeamMember ProfileImg={AnamImg} Title1="Anam Khan" Title2="Property Consultant" Link="/anam" />

                    <TeamMember ProfileImg={AnumImg} Title1="Anum" Title2="Property Consultant" Link="/anum" />

                    {/* <TeamMember
                            ProfileImg={ArsalanImg}
                            Title1="Rashmi"
                            Title2="Property Consultant"
                            Link="/rashmi"
                        /> */}

                    <TeamMember
                        ProfileImg={AjmalImg}
                        Title1="Ajmal Musthafa"
                        Title2="Marketing Manager"
                        Link="/ajmal-musthafa"
                    />

                    <TeamMember
                        ProfileImg={FrancisImg}
                        Title1="Francis Mari"
                        Title2="Administrative Executive"
                        Link="/francis-mari"
                    />

                    <TeamMember
                        ProfileImg={LakshayImg}
                        Title1="Lakshay Choudhary"
                        Title2="Property Consultant"
                        Link="/lakshay-choudhary"
                    />

                    {/* <TeamMember
                            ProfileImg={ArsalanImg}
                            Title1="Mohammad Salman Badusha"
                            Title2="Content Director"
                            Link="/mohammad-salman-badusha"
                        /> */}
                </div>
            </div>

            <section className="pt-5 mt-md-5" />

            <Footer />
        </>
    )
}

export default TeamPage
